<div *ngFor="let message of singleMessages.messages">
  <app-single-message-editor
    [editorConfig]="editorConfig"
    [favoritesAllLang]="favoritesAllLang"
    [isPublish]="isPublish"
    [isReplyingInPrivate]="false"
    [message]="message"
    [siteId]="singleMessages.siteId">
  </app-single-message-editor>
</div>
